import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Retreats from "./metadata.json";
import { DiscourseCard } from "../../components/card/DiscourseCard";
import CustomizedAccordions from "../../components/Accordion/Accordion";
import { Divider } from "@mui/material";

const BUCKET_URL = "https://audio-discourses.s3.us-east-2.amazonaws.com";

export const AudioDiscourseList = () => {
  const [files, setFiles] = useState([]);
  useEffect(() => {
    fetch(`${BUCKET_URL}/metadata.json`)
      .then((res) => res.json())
      .then(setFiles)
      .catch(console.error);
  }, []);

  // useEffect(() => {
  //   setFiles(Retreats);
  // }, []);
  // const renderList = () => {
  //   return files.map((retreat, index) => {
  //     return (
  //       <div
  //         key={`${retreat.retreat.name}-${index}`}
  //         className="retreat-container"
  //       >
  //         <div className="sub-container">
  //           <span className="subtitle">{retreat.retreat.name}</span>
  //         </div>
  //         <div
  //           style={{
  //             margin: "12px",
  //           }}
  //           className="book-card-container"
  //           key={retreat.retreat.name + index}
  //         >
  //           {retreat.data.map((item, index) => {
  //             return (
  //               <DiscourseCard
  //                 key={`${retreat.retreat.name}-${item.name}-${index}`}
  //                 {...{ ...item, retreat: retreat.retreat.name }}
  //                 size={"sm"}
  //                 bucket={BUCKET_URL}
  //               />
  //             );
  //           })}
  //         </div>
  //       </div>
  //     );
  //   });
  // };
  const renderDiscourseList = () => {
    const list = files.map((retreat, index) => {
      return {
        accordionName: retreat.retreat.name,
        headerChild: (
          <div className="sub-container">
            <span className="subtitle">{retreat.retreat.name}</span>
          </div>
        ),
        bodyChild: (
          <div
            style={{
              margin: "12px",
            }}
            className="book-card-container"
            key={"discourse" + retreat.retreat.name + index}
          >
            {retreat.data.map((item, index) => {
              return (
                <DiscourseCard
                  key={`${retreat.retreat.name}-${item.name}-${index}`}
                  {...{ ...item, retreat: retreat.retreat.name }}
                  size={"sm"}
                  bucket={BUCKET_URL}
                />
              );
            })}
          </div>
        ),
      };
    });
    return <CustomizedAccordions key={"discourse-audio"} data={list} />;
  };
  // const renderDiscourseList = () => {
  //   return files.map((retreat, index) => {
  //     return (
  //       <div
  //         key={`${retreat.retreat.name}-${index}`}
  //         className="retreat-container"
  //       >
  //         <div className="sub-container">
  //           <span className="subtitle">{retreat.retreat.name}</span>
  //         </div>
  //         <div
  //           style={{
  //             margin: "12px",
  //           }}
  //           className="book-card-container"
  //           key={retreat.retreat.name + index}
  //         >
  //           {retreat.data.map((item, index) => {
  //             return (
  //               <DiscourseCard
  //                 key={`${retreat.retreat.name}-${item.name}-${index}`}
  //                 {...{ ...item, retreat: retreat.retreat.name }}
  //                 size={"sm"}
  //                 bucket={BUCKET_URL}
  //               />
  //             );
  //           })}
  //         </div>
  //       </div>
  //     );
  //   });
  // };

  const rendeTranscriptions = () => {
    const transcriptsContainingItems = [];
    const downloadBook = async (fileURI) => {
      const response = await fetch(`${BUCKET_URL}/${fileURI}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileURI;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    };
    files.forEach((item) =>
      item.data.some((val) => {
        if (val.transcribe) {
          transcriptsContainingItems.push({
            ...val,
            retreat: item.retreat.name,
          });
        }
      }),
    );
    return transcriptsContainingItems.map((item, index) => {
      return (
        <div
          key={"transcript" + item.retreat + index}
          className="line-wrapper"
          onClick={() => downloadBook(`${item.retreat}/${item.transcribeUrl}`)}
        >
          <div className="download-text trans-button">
            <span className="trans-text-down">Download</span> -{" "}
            <span className="trans-text">
              {item.transcribe} ({item.transcriptionSize})
            </span>
          </div>
        </div>
      );
    });
  };
  return (
    <Container maxWidth="lg">
      <div style={{ marginBottom: "30px" }}>
        <div className="sub-container">
          <span className="subtitle">Edited Transcriptions</span>
        </div>
        <div className="trans-container">{rendeTranscriptions()}</div>
      </div>
      <Divider sx={{ backgroundColor: "rgba(156, 121, 25, 0.4745098039)", height: 2 }}/>
      {/* <div className="book-card-container">{renderList()}</div> */}
      <div className="book-card-container" style={{ marginTop: "20px" }}>
        {renderDiscourseList()}
      </div>
    </Container>
  );
};

const AudioDiscourses = () => {
  return (
    <div className="App">
      <div className="article">
        <h1>Audio Dhamma Discourses</h1>
        <p>
          These Dhamma discourses are largely recordings from recent retreats
          and meetings focusing on the Buddhist path, meditation instructions
          and the questions of the retreatants. The transcripts of these audio
          discourses (where available) have been lightly edited and polished for
          publication.
        </p>
      </div>
      <AudioDiscourseList key={"audio-discourse"} />
    </div>
  );
};

export default AudioDiscourses;

// TODOS
// m in samsara should change to right font
